import { billingEventSchemas } from "./billing.js";
import { bookingEventSchemas } from "./booking.js";
export * from "./billing.js";
export * from "./booking.js";
/**
 * Every feature's event schemas, flattened into one list for the union in `../index.ts`.
 *
 * A new feature adds its file, exports a `<feature>EventSchemas` array from it, and appends
 * that array here. Nothing else changes - the union, the validator and the inferred types
 * all pick it up from this list.
 */
export const allEventSchemas = [
    ...billingEventSchemas,
    ...bookingEventSchemas,
];
//# sourceMappingURL=index.js.map